export default __webpack_public_path__ + "d3efce7a8ad1d8a563fe60431b3fb4ab.jpg";